import React from 'react';

import ColorsSpread from '../../../../images/affinities/colors-spread.jpg';
import LandscapesSpread from '../../../../images/affinities/landscapes-spread.jpg';
import Cover from '../../../../images/affinities/cover.jpg';

import '../../../styles/common/promos/affinities-banner.scss';

const AffinitiesBanner = (props) => (
  <div className="sitewide-banner affinities-banner">
    <a href="https://tinyurl.com/ykttx9s9">
      <div className="contents page-width">
        <div className="left-side">
          <div className="images">
            <div className="spread"><img src={ ColorsSpread } alt="Sample two page spread" /></div>
            <div className="cover"><img src={ Cover } alt="Rendering of book showing cover and spine" /></div>
          </div>
        </div>
        <div className="details">
          <span className="subhead">
            A limited number of the clothbound edition of <span className="title">AFFINITIES</span> — our special
            book of images — have become available from the publisher.<br />
            Less than 150 left.
          </span>
          <span className="cta-button">
            Order Today
          </span>
          <span className="footer">
            500+ images – 368 pages – Large-format – Cloth-bound hardcover
          </span>
        </div>
        <div className="right-side">
          <div className="images">
            <div className="cover"><img src={ Cover } alt="Rendering of book showing cover and spine" /></div>
            <div className="spread"><img src={ LandscapesSpread } alt="Sample two page spread" /></div>
          </div>
        </div>
      </div>
    </a>
  </div>
);

export default AffinitiesBanner;